<template>
  <el-scrollbar wrap-class="scrollbar-wrapper">
    <el-menu
      :default-active="$route.path"
      :collapse="isCollapse"
      :background-color="variables.menuBg"
      :text-color="variables.menuText"
      :active-text-color="variables.menuActiveText"
      :collapse-transition="false"
      mode="vertical"
    >
      <sidebar-item v-for="route in routes" :key="route.path" :item="route" :base-path="route.path"/>
    </el-menu>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import variables from '@/styles/variables.scss'
import SidebarItem from './SidebarItem'

export default {
  components: { SidebarItem },
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    routes() {
      return this.$store.getters.permission_routes
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  },
  created() {
    this.getList()
    this.getRedDot()
  },
  methods: {
    getList() {
      this.$store.dispatch('GetTaskNewNotes', {
        UserID: this.$store.getters.name
      }).then(() => {}).catch(err => {
        console.log(JSON.stringify(err))
      })
    },
    getRedDot() {
      this.$store.dispatch('GetRedDot', {
        UserID: this.$store.getters.userid
      }).then(() => {}).catch(err => {
        console.log(JSON.stringify(err))
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue